<template>
  <div>
    <div class="demo-type">
      <el-avatar
        :size="90"
        :src="`http://oss.deyity.com/img/user_photo/${imageUrl}`"
        @error="errorHandler"
      >
        <img :src="`http://oss.deyity.com/img/user_photo/${imageUrl}`" />
      </el-avatar>
      <div class="demo-h">
        <el-link @click="imageFN">编辑头像</el-link>
      </div>
    </div>
    <input
      type="file"
      ref="picpath"
      style="display: none"
      accept="image/*"
      @change="handleFile"
      class="hiddenInput"
    />
    <el-dialog v-model="dialogVisible" title="编辑头像" width="30%" center>
      <div class="cropper-content">
        <div class="cropper" style="text-align: center">
          <vueCropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.outputSize"
            :outputType="option.outputType"
            :info="option.info"
            :canScale="option.canScale"
            :autoCrop="option.autoCrop"
            :autoCropWidth="option.autoCropWidth"
            :autoCropHeight="option.autoCropHeight"
            :fixed="option.fixed"
            :fixedBox="option.fixedBox"
            :fixedNumber="option.fixedNumber"
          ></vueCropper>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="finish" :loading="loading"
            >确定</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import "vue-cropper/dist/index.css";
import { VueCropper } from "vue-cropper";
import { getCurrentInstance, reactive, ref, watch, inject } from "vue";
export default {
  components: {
    VueCropper,
  },
  props: ["AUTH_OBJ", "token"],
  setup(props) {
    let imageUrl = ref("");
    let dialogVisible = ref(false);
    let { proxy: _this } = getCurrentInstance();
    // 刷新
    const refresh = inject("reload");
    let picsList = ref([]); //页面显示的数组
    // 防止重复提交
    let loading = ref(false);
    let fileinfo = ref({});

    // 裁剪组件的基础配置option

    let option = reactive({
      img: "", // 原图文件
      autoCrop: true, // 默认生成截图框
      fixedBox: false, // 固定截图框大小
      canMoveBox: true, // 截图框可以拖动
      autoCropWidth: 150, // 截图框宽度
      autoCropHeight: 150, // 截图框高度
      fixed: true, // 截图框宽高固定比例
      fixedNumber: [1, 1], // 截图框的宽高比例
      centerBox: true, // 截图框被限制在图片里面
      canMove: false, // 上传图片不允许拖动
      canScale: false, // 上传图片不允许滚轮缩放
    });
    // let { proxy: _this } = getCurrentInstance()
    watch(
      () => props.AUTH_OBJ,
      (n) => {
        imageUrl.value = n.photo;
      },
      { immediate: true }
    );
    // 点击图片 跳转input属性
    let picpath = ref("");
    let imageFN = () => {
      picpath.value.click();
    };
    // 裁剪后图片上传
    let cropper = ref(null);
    let finish = () => {
      cropper.value.getCropBlob(async (data) => {
        let param = new FormData();
        param.append("photo", data);
        try {
          let res = await _this.$http.put(`/auth/user/set_photo`, param);
          // 获取图片重新缓冲
          let AUTH_TOKEN = JSON.parse(
            window.localStorage.getItem("AUTH_TOKEN")
          );
          AUTH_TOKEN.photo = res.data.data.photo;
          localStorage.setItem("AUTH_TOKEN", JSON.stringify(AUTH_TOKEN));
          refresh();
          dialogVisible.value = false;
          _this.$notify({
            title: "提示",
            message: "图片修改成功",
            type: "warning",
          });
        } catch (error) {
          console.log(error);
          _this.$notify({
            title: "提示",
            message: error.response.data.message,
            type: "error",
          });
        }
      });
    };
    // 选择图片 是否读取成功
    let selectImg = (file) => {
      // 创建FileReader的实例用于读取文件
      let reader = new FileReader();
      // // 读取成功的操作  ( 更换头像 )
      reader.readAsDataURL(file);
      reader.onload = (data) => {
        let res = data.target || data.srcElement;
        // res.result 为图片的base64格式, 直接放入img标签的src中即可
        option.img = res.result;
        dialogVisible.value = true;
      };
      // 读取失败的操作
      reader.onerror = () => {
        _this.$message.error("图片读取失败");
      };
    };
    let handleFile = (e) => {
      let $target = e.target || e.srcElement;
      // 获取到上传的file
      let file = $target.files[0];
      // 读取图片
      selectImg(file);
    };
    let errorHandler = () => {
      return true;
    };
    return {
      option,
      imageUrl,
      dialogVisible,
      picsList,
      loading,
      fileinfo,
      finish,
      cropper,
      handleFile,
      picpath,
      imageFN,
      errorHandler,
    };
  },
};
</script>

<style lang="less" scoped>
.avatar-uploader {
  background: red !important;
  width: 150px;
  height: 150px;
  text-align: center;
  line-height: 150px;
}
.el-icon-plus {
  width: 150px;
  height: 150px;
  font-size: 30px;
}
.cropper-content {
  width: 500px;
  height: 500px;
  background: pink;
}
.cropper {
  width: 500px;
  height: 500px;
  background: yellow;
}
.demo-type {
  position: relative;
  width: 96px;
  height: 96px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 50%;
  border: 1px solid #eee;
  box-shadow: 0 0 10px #eee;
  &:hover .demo-h {
    opacity: 1;
  }
  .demo-h {
    opacity: 0;
    position: absolute;
    top: 0;
    z-index: 2;
    left: 0;
    background: rgba(0, 0, 0, 0.6);
    width: 100%;
    height: 100%;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    .el-link {
      color: #409eff;
    }
  }
}
</style>
